import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'

import { ObservabilityTool } from 'components/status-checks/authentication-form-utils'
import { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useTranslation } from 'hooks/use-translation'

export const ObservabilityToolDomainSelect: React.FC<{
  handleSelectDomain: (e: SelectChangeEvent, field: object) => void
  isEdit: boolean
  selectedObservabilityTool: ObservabilityTool
}> = ({ handleSelectDomain, isEdit, selectedObservabilityTool }) => {
  const { trans } = useTranslation()
  const form = useFormContext<StatusCheckFormValues>()
  const { control, formState } = form

  return (
    <FormControl sx={{ width: '50%' }}>
      <InputLabel>
        {trans(
          'forms.save_status_check.select_observability_tool_and_domain.domain.select_field.label'
        )}
      </InputLabel>
      <Controller
        control={control}
        name="domain.name"
        render={({ field }) => (
          <Select
            {...field}
            disabled={isEdit}
            label={trans(
              'forms.save_status_check.select_observability_tool_and_domain.domain.select_field.label'
            )}
            onChange={(e) => handleSelectDomain(e, field)}
          >
            {selectedObservabilityTool?.domains?.map(
              ({ name, integrationType }) => (
                <MenuItem key={integrationType} value={name}>
                  {name}
                </MenuItem>
              )
            )}
          </Select>
        )}
      />
      <FormHelperText error={Boolean(formState.errors.domain)}>
        {formState.errors.domain?.message}
      </FormHelperText>
    </FormControl>
  )
}
